import {
  Box,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';

import ForgotPassword from './ForgotPassword';
import LoginContainer from './LoginContainer';
import NewPassword from './NewPassword';
import { PRIMARY } from '../constants/style';
import { useAppDispatch, useAppSelector } from '../store';
import { getAuth, setLoginRoute } from '../features/authSlice';

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { loginRoute } = useAppSelector(getAuth);
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState<string>('');

  const forgotPasswordHandler = (route: string) => {
    // setEmail('');
    dispatch(setLoginRoute(route));
  };

  return (
    <div>
      <Grid
        container
        style={{
          maxHeight: '100vh',
          height: '100vh',
        }}
      >
        <Grid
          sx={{
            bgcolor: '#05162a',
            ...(isMobile && { display: 'none' }),
            position: 'relative',
          }}
          item
          xs={0}
          sm={6}
          lg={6}
          md={6}
        >
          <Box
            px={4.5}
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              position: 'relative',
            }}
          >
            <Box
              p={4.5}
              sx={{
                bgcolor: '#05162a',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            >
              {/* <SBM_logo /> */}
            </Box>
            <Box>
              <Typography
                fontSize={48}
                className="font-aspekta-300"
                color={'white'}
              >
                Welcome to
              </Typography>
              <Typography
                fontSize={48}
                className="font-aspekta-700"
                color={'#c8a864'}
              >
                Dashboard
              </Typography>
              <Box
                sx={{
                  width: '52px',
                  height: '3px',
                  bgcolor: 'white',
                  my: 3,
                }}
              ></Box>
              <Typography
                fontSize={14}
                className="font-aspekta-500"
                color={'white'}
              >
                Collection Management System
              </Typography>
            </Box>
            <Stack
              direction={'row'}
              gap={3}
              p={4.5}
              sx={{
                bgcolor: '#05162a',
                position: 'absolute',
                bottom: 0,
                left: 0,
              }}
            >
              <Typography
                fontSize={8}
                className="font-aspekta-600"
                color={'white'}
                letterSpacing={'1px'}
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                terms and conditions
              </Typography>
              <Typography
                fontSize={8}
                className="font-aspekta-600"
                color={'white'}
                letterSpacing={'1px'}
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                privacy policy
              </Typography>
            </Stack>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          style={{
            background: '#F6F9FF',
            position: 'relative',
          }}
        >
          {loginRoute === 'FORGOT' ? (
            <ForgotPassword
              forgotPasswordHandler={forgotPasswordHandler}
              email={email}
              setEmail={setEmail}
            />
          ) : loginRoute === 'NEW_PASSWORD' ? (
            <NewPassword forgotPasswordHandler={forgotPasswordHandler} />
          ) : (
            <LoginContainer forgotPasswordHandler={forgotPasswordHandler} />
          )}
          {isMobile && (
            <Box
              p={4.5}
              sx={{
                bgcolor: PRIMARY.main,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
              }}
            >
              {/* <SBM_logo /> */}
            </Box>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
